/* eslint-disable max-len */

import { RECURRENCE_NAMESPACE } from '@pflegix/i18n';

export const ORDER_HEADER_DATA_TRANSLATION_EN = {
  duration_one: 'Hour',
  duration_other: 'Hours',
  visit_one: 'Visit',
  visit_other: 'Visits',
  period: '{{startAt, datetime}} - {{endAt, datetime}}',
  period_open_end: '{{startAt, datetime}} - Open end',
  frequency: `$t(${RECURRENCE_NAMESPACE}:{{rhythm, lowercase}}) $t(visit, {"count": {{visits}} }) for $t(duration, {"count": {{duration}} })`,
} as const;
